<template>
<div class="card mb-3">
  <div class="card-body name-resolver">
    <div class="row form-inline mb-2">
      <div class="col-2">
        <label>Name resolver:</label>
      </div>
      <div class="col-5">
        <b-input-group>
          <b-form-input type="text" v-model="objectName" placeholder="Object name" v-on:keyup.enter="resolve" class="name_resolver_input"></b-form-input>
          <b-input-group-append>
            <b-button v-on:click="resolve">Resolve</b-button>
          </b-input-group-append>
        </b-input-group>
        <span class="text-danger" v-if="resolverError">{{resolverError}}</span>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="row form-inline">
          <div class="col-3">
            <b-form-checkbox v-model="ra_sel">RA</b-form-checkbox>
          </div>
          <div class="col">
            <b-form-input v-model="ra" class="ra_input mr-3 w-100" placeholder="hh:mm:ss.ss"></b-form-input>
            <span class="text-danger" v-if="raError">{{raError}}</span>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="row form-inline">
          <div class="col-3">
            <b-form-checkbox v-model="dec_sel">Dec</b-form-checkbox>
          </div>
          <div class="col">
            <b-form-input v-model="dec" class="dec_input mr-3 w-100" placeholder="dd:mm:ss.ss"></b-form-input>
            <span class="text-danger" v-if="decError">{{decError}}</span>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="row form-inline">
          <div class="col-6">
            <label>Radius (arcmin)</label>
          </div>
          <div class="col">
            <b-form-input v-model="radius" class="fit-width"></b-form-input>
            <span class="text-danger" v-if="radiusError">{{radiusError}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="name-resolver-loading" v-show="loading">
      <div class="spinner-wrapper">
        <b-spinner variant="primary"></b-spinner>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import client from 'api-client';

export default {
  name: 'NameResolver',
  computed: {
    fields() { return this.$store.state.searchForm.fields },
    searchForm() { return this.$store.state.searchForm },
    ra_sel: {
      get() {
        return this.fields[this.fieldsPrefix + '_ra_sel'];
      },
      set(value) {
        this.fields[this.fieldsPrefix + '_ra_sel'] = value;
      }
    },
    ra: {
      get() {
        return this.fields[this.fieldsPrefix + '_ra'];
      },
      set(value) {
        this.fields[this.fieldsPrefix + '_ra'] = value;
      }
    },
    dec_sel: {
      get() {
        return this.fields[this.fieldsPrefix + '_dec_sel'];
      },
      set(value) {
        this.fields[this.fieldsPrefix + '_dec_sel'] = value;
      }
    },
    dec: {
      get() {
        return this.fields[this.fieldsPrefix + '_dec'];
      },
      set(value) {
        this.fields[this.fieldsPrefix + '_dec'] = value;
      }
    },
    radius: {
      get() {
        return this.fields[this.fieldsPrefix + '_radius'];
      },
      set(value) {
        this.fields[this.fieldsPrefix + '_radius'] = value;
      }
    },
    raError() {
      return this.searchForm.fieldErrors[this.fieldsPrefix + '_ra']
    },
    decError() {
      return this.searchForm.fieldErrors[this.fieldsPrefix + '_dec']
    },
    radiusError() {
      return this.searchForm.fieldErrors[this.fieldsPrefix + '_radius']
    }
  },
  data: function() {
    return {
      loading: false,
      objectName: '',
      resolverError: ''
    };
  },
  props: {
    fieldsPrefix: {
      type: String,
      default: 'main'
    }
  },
  methods: {
    resolve() {
      let self = this;
      self.loading = true;
      self.resolverError = '';
      client.nameResolver(self.objectName)
        .then(res => {
          self.ra = res.ra;
          self.dec = res.dec;
          self.radius = res.radius;
          self.loading = false;
        })
        .catch(res => {
          switch (res.status) {
            case 400:
              self.resolverError = res.data.message;
              break;
            case 404:
              self.resolverError = res.data.message;
              break;
          }
          self.loading = false;
        });
    }
  },
  mounted() {
    this.$root.$on('resetFields', () => {
      this.resolverError = '';
      this.objectName = '';
    });
  }
}
</script>

<style>
.name-resolver {
  padding-bottom: 16px;
}

.name-resolver-loading {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 1000;
}
</style>
